module.exports = __webpack_public_path__ + "static/media/02B.0fd10070.png";